import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { loadConfig } from "@rtvloco/platform/env";
import { validateEnv } from "./config/envValidation";
import { initAppTracing } from "./observability/tracing";
import { themeManager } from "@rtvloco/theme/ThemeManager";
import "./styles.css";
import "./i18n/config";


const AppLoadingSkeleton = () => (
  <div className="sentinel-loading-skeleton">Loading Sentinel...</div>
);

async function bootstrap() {
  await loadConfig();
  themeManager.initialize();
  initAppTracing();
  const { default: App } = await import("./App");
  validateEnv();
  ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    <React.StrictMode>
      <Suspense fallback={<AppLoadingSkeleton />}>
        <App />
      </Suspense>
    </React.StrictMode>
  );
}

bootstrap().catch((err) => {
  const root = document.getElementById("root");
  if (root) root.textContent = String(err);
});
